module.exports = __webpack_public_path__ + "static/media/benevolent_autocrat.5130bdeb.png";